import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

export const Calendar = ({ selected, onSelect, className, ...props }) => {
  return (
    <DatePicker
      selected={selected}
      onChange={onSelect}
      className={`calendar bg-blanco-nieve text-azul-lago border border-azul-lago rounded-md ${className}`} // Aplicamos los colores de la paleta
      {...props}
    />
  );
};
